// Envelope helpers shared by all clients. Mirrors protocol/envelope.schema.json.
// Builders never throw on bad input client-side; receivers ignore unknown types.

export const ENVELOPE_VERSION = 1;

export function envelope({ type, session, from, payload }) {
  return {
    v: ENVELOPE_VERSION,
    type,
    session,
    from,
    ts: Date.now(),
    payload: payload ?? {},
  };
}

export function isValid(msg) {
  return !!msg
    && msg.v === ENVELOPE_VERSION
    && typeof msg.type === 'string'
    && typeof msg.session === 'string'
    && typeof msg.from === 'string'
    && typeof msg.ts === 'number';
}

// Topic builders — single source of truth for topic naming.
export const topics = {
  state:      (s) => `sessions/${s}/state`,
  control:    (s) => `sessions/${s}/control`,
  presence:   (s) => `sessions/${s}/presence`,
  media:      (s) => `sessions/${s}/media`,
  annotation: (s) => `sessions/${s}/annotation`,
  audience:   (s) => `sessions/${s}/audience`,
  telemetry:  (s) => `sessions/${s}/telemetry`,
  // Wildcard for admin to monitor everything
  allForSession: (s) => `sessions/${s}/+`,
  allSessions:   ()  => `sessions/+/+`,
};

// Event type constants — keeps typos out of code.
export const EventType = Object.freeze({
  SLIDE_CHANGED: 'slide.changed',
  PRESENCE_ONLINE:    'presence.online',
  PRESENCE_OFFLINE:   'presence.offline',
  PRESENCE_HEARTBEAT: 'presence.heartbeat',
  CONTROL_PAUSE:    'control.pause',
  CONTROL_OVERVIEW: 'control.overview',
  CONTROL_BLACKOUT: 'control.blackout',
  CONTROL_SYNC_NOW: 'control.sync_now',
  MEDIA_PLAY:  'media.play',
  MEDIA_PAUSE: 'media.pause',
});

// Topic-mapping for each event type. Used by clients to know where to publish.
export function topicFor(type, session) {
  if (type.startsWith('slide.'))      return topics.state(session);
  if (type.startsWith('control.'))    return topics.control(session);
  if (type.startsWith('presence.'))   return topics.presence(session);
  if (type.startsWith('media.'))      return topics.media(session);
  if (type.startsWith('annotation.')) return topics.annotation(session);
  if (type.startsWith('audience.'))   return topics.audience(session);
  if (type.startsWith('telemetry.'))  return topics.telemetry(session);
  throw new Error(`Unknown event type prefix: ${type}`);
}
